<div #rmsSelectToggle class="rms-select-toggle" (click)="showRmsSelect = !showRmsSelect;">
    <span class="icon-ui-search toggle-icon"></span>
</div>
<div #rmsSelectContainer class="rms-select">
    <select *ngIf="showRmsSelect" [ngModel]="county" (ngModelChange)="onCountyChange($event)" id="county" class="select"
        name="county">
        <option [ngValue]="null">County...</option>
        <option *ngFor="let county of counties" [ngValue]="county">
            {{ county.name }} ({{ county.countyCode }})</option>
    </select>
    <select *ngIf="showRmsSelect" [ngModel]="route" (ngModelChange)="onRouteChange($event)" name="route" id="route"
        class="select" [disabled]="!county">
        <option [ngValue]="null">Route...</option>
        <option *ngFor="let route of filteredRoutes" [ngValue]="route">
            {{ route.stateRouteNumber }} ({{ route.streetNames }})
        </option>
    </select>
    <select *ngIf="showRmsSelect" [ngModel]="segment" (ngModelChange)="onSegmentChange($event)" name="segment"
        id="segment" class="select" [disabled]="!route">
        <option [ngValue]="null">Segment...</option>
        <option *ngFor="let segment of filteredSegments" [ngValue]="segment">
            {{ segment.segmentNumber }} - {{ segment.streetName }}</option>
    </select>
    <input *ngIf="showRmsSelect" [(ngModel)]="offset" (ngModelChange)="onOffsetChange($event)" type="number" placeholder="Offset..." min="0"
        [max]="segment?.segmentLength" step="25" [disabled]="!segment">
</div>